module.exports = __webpack_public_path__ + "img/index_foot.9739ae55.png";